var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionSelectedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#141619",
    stroke: "#525F6B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 20.1698L8.83016 15.9998L7.41016 17.4098L13.0002 22.9998L25.0002 10.9998L23.5902 9.58984L13.0002 20.1698Z",
    fill: "#00AB58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionSelectedDark);
export default __webpack_public_path__ + "static/media/optionSelectedDark.9a427285982f41abaeb9e2fd2ea2827d.svg";
export { ForwardRef as ReactComponent };